export enum IntegrityType {
  MockLocation = 'MOCK_LOCATION',
  GpsDisabled = 'GPS_DISABLED',
  PermissionDenied = 'PERMISSION_DENIED',
  NetworkDisabled = 'NETWORK_DISABLED',
  BatteryIsLow = 'BATTERY_IS_LOW',
  DeviceRebooted = 'DEVICE_REBOOTED',
  DeveloperOptionEnabled = 'DEVELOPER_OPTION_ENABLED',
  RootedDevice = 'ROOTED_DEVICE',
  VpnDetected = 'VPN_DETECTED',
  ActivityRecognitionPermissionDenied = 'ACTIVITY_RECOGNITION_PERMISSION_DENIED',
}
